import React, { useState } from 'react'
import { ScrollView, StyleSheet, View } from 'react-native'

import { useFocusEffect, useLocalSearchParams } from 'expo-router'

import { CardList, PaddedLayout, Text } from '../../components'
import { RankingCards } from '../../screens'
import { rankings } from './data'

export const AllRankingsScreen = () => {
  const params = useLocalSearchParams<{ ranking: string }>()
  const [rankingData, setRankingData] = useState<RankingCards>()
  const paramsRanking = params.ranking || ''

  useFocusEffect(
    React.useCallback(() => {
      if (paramsRanking) {
        const currentRanking = rankings.find((ranking: RankingCards) => ranking.name === paramsRanking)
        if (!currentRanking) {
          return
        }
        setRankingData(currentRanking)
      }
    }, [paramsRanking, setRankingData])
  )

  return (
    <PaddedLayout>
      <ScrollView>
        <Text text={rankingData?.displayName} style={styles.title} />
        {rankingData?.rankingCards.map((hand, index) => (
          <View key={index} style={styles.handContainer}>
            <View style={styles.handTitleContainer}>
              <Text text={`${index + 1}.`} style={[styles.handIndex, styles.handTitle]} />
              <Text text={hand.name} style={styles.handTitle} />
            </View>
            <CardList contentContainerStyles={{ justifyContent: 'flex-start' }} cards={hand.cards} />
          </View>
        ))}
      </ScrollView>
    </PaddedLayout>
  )
}

const styles = StyleSheet.create({
  title: { fontSize: 20, fontWeight: 'bold', paddingBottom: 20 },
  handContainer: { paddingBottom: 15 },
  handTitleContainer: { flexDirection: 'row', paddingBottom: 5 },
  handTitle: { fontWeight: 'bold', fontSize: 16 },
  handIndex: { paddingRight: 2 },
  description: {
    fontFamily: 'SF Pro Display',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: 14,
    lineHeight: 17,
    textAlign: 'center',
    color: '#FFFFFF'
  }
})
